export default {
      id: "checkbox-usage",
      viewBox: "0 0 105.15 95.879",
      url: __webpack_public_path__ + "live-atlas/img/icons.e641665a.svg#checkbox",
      toString: function () {
        return this.url;
      }
    }